import { Component, Input, OnInit } from '@angular/core';
// Forms
import { FormGroup, FormGroupDirective } from '@angular/forms';
// Library types
import { OrganizationTypeEnum, Profile, RoleTypeEnum } from '@mocca-technologies/model';

export enum IdType {
  DNI = 'DNI',
  NIE = 'NIE',
  CIF = 'CIF',
}

const ROLES_PER_ORG: Partial<Record<OrganizationTypeEnum, Array<keyof typeof RoleTypeEnum>>> = {
  [OrganizationTypeEnum.ORG_DRONE_OPERATOR]: ['ROLE_OP_MANAGER', 'ROLE_OP_PILOT'],
  [OrganizationTypeEnum.ORG_INFRASTRUCTURE_OPERATOR]: [
    'ROLE_INFRST_MANAGER',
    'ROLE_INFRST_SAFEFY',
    'ROLE_INFRST_SERVICE_PROVIDER',
    'ROLE_INFRST_PRIVILEGED',
    'ROLE_INFRST_OBSERVER',
  ],
};

@Component({
  selector: 'app-mocca-details',
  templateUrl: './mocca-details.component.html',
  styleUrls: ['./mocca-details.component.scss'],
})
export class MOCCADetailsComponent implements OnInit {

  /**
   * Variables
   */
  PilotForm: FormGroup;

  /**
   * Enum variables
   */
  idTypes = Object.values(IdType);
  pilotProfiles: Array<keyof typeof Profile> = ['auth', 'admin'];

  /**
   * Input parameters
   */
  @Input() isForEnrolment: boolean = false;
  @Input() isAdmin: boolean = false;
  @Input() organizationType: string = '';

  get availableRoles(): Array<keyof typeof RoleTypeEnum> {
    return (
      ROLES_PER_ORG[this.organizationType as OrganizationTypeEnum] ??
      ROLES_PER_ORG[OrganizationTypeEnum.ORG_DRONE_OPERATOR]
    );
  }

  constructor(private rootFormGroup: FormGroupDirective) { }

  // #region --> LifeCycle

  /**
   * Every time the component is rendered, we take from the parent the pilot form.
   */
  ngOnInit() {
    this.PilotForm = this.rootFormGroup.control;
  }

  // #endregion --> LifeCycle
}
